import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerLeftDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerLeftDown"><Path d="M19.5 3.5H9V20.25" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 16.25L9 20.75L4.5 16.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerLeftDown;
